// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__N__sl","providerImage":"styles_providerImage__aSSuO","blured":"styles_blured__00dNH"};